import { createContext, useContext } from 'react';

interface NotificationTrayContextType {
    openTray: () => void;
}

export const NotificationTrayContext = createContext<NotificationTrayContextType>({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openTray: () => {},
});

export const useNotificationTray = (): NotificationTrayContextType => useContext(NotificationTrayContext);
